module.exports = __webpack_public_path__ + "img/sk-flag.92fe1415.svg";